import { Box, Divider, Skeleton } from '@mui/material'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'

export interface HeaderLoadingProps {
  /** Number of chip skeletons to show (default: 3) */
  chipCount?: number
  /** Whether to show the icon/title section (default: true) */
  showIconTitle?: boolean
  /** Whether to show vertical chips (default: true) */
  showVerticals?: boolean
}

const HeaderLoading: React.FC<HeaderLoadingProps> = ({ chipCount = 3, showIconTitle = true, showVerticals = true }) => {
  const { pinned } = useLayoutContext()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 3,
        position: 'sticky',
        zIndex: 901,
        marginLeft: 5,
        mr: 1,
        p: 0.8,
        pt: pinned ? '60px' : 0.8,
        transition: 'padding 0.3s ease',
      }}
    >
      {/* Avatar skeleton */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 2 }}>
        <Skeleton variant="circular" width={50} height={50} animation="wave" />
        {/* Name skeleton */}
        <Skeleton variant="text" width={140} height={32} animation="wave" />
      </Box>

      {/* Icon and Title section */}
      {showIconTitle && (
        <>
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="circular" width={24} height={24} animation="wave" />
            <Skeleton variant="text" width={80} height={24} animation="wave" />
          </Box>
        </>
      )}

      {/* Vertical chips skeleton */}
      {showVerticals && (
        <>
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Skeleton variant="rounded" width={100} height={24} animation="wave" sx={{ borderRadius: '16px' }} />
          </Box>
        </>
      )}

      {/* Status chips skeleton */}
      {chipCount > 0 && (
        <>
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
          <Box sx={{ display: 'flex', gap: 1 }}>
            {Array.from({ length: chipCount }).map((_, index) => (
              <Skeleton
                key={index}
                variant="rounded"
                width={80 + index * 20}
                height={24}
                animation="wave"
                sx={{ borderRadius: '16px' }}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  )
}

export default HeaderLoading
